import { MODE_AIR, MODE_RAIL, MODE_ROAD, MODE_WATER } from '@/lib/constants';
import { RouteModel } from '@/lib/models/route/types';
import {
  calcE2eRouteEmissionsStats,
  calcRouteModeEmissionsStats,
} from '@/lib/models/route/utils/calculate-route-emission-stats';
import { RouteStatsInterface } from '@/types';

export const generateRouteStats = (routes: RouteModel[]): RouteStatsInterface => {
  const oceanRoutes = routes.filter((route) => route.primaryMode === MODE_WATER);
  const oceanRouteSCount = oceanRoutes.length;
  const airRoutes = routes.filter((route) => route.primaryMode === MODE_AIR);
  const airRoutesCount = airRoutes.length;
  const roadRoutes = routes.filter((route) => route.primaryMode === MODE_ROAD);
  const roadRoutesCount = roadRoutes.length;
  const railRoutes = routes.filter((route) => route.primaryMode === MODE_RAIL);
  const railRoutesCount = railRoutes.length;

  // E2E Emissions (includes road links)
  const e2eAirEmissions = calcE2eRouteEmissionsStats(airRoutes);
  const e2eOceanEmissions = calcE2eRouteEmissionsStats(oceanRoutes);
  // Mode only Emissions
  const airEmissions = calcRouteModeEmissionsStats(airRoutes);
  const oceanEmissions = calcRouteModeEmissionsStats(oceanRoutes);

  return {
    totalRoutes: routes.length,
    airRoutes: airRoutesCount,
    oceanRoutes: oceanRouteSCount,
    railRoutes: railRoutesCount,
    roadRoutes: roadRoutesCount,
    emissions: {
      e2e: {
        air: e2eAirEmissions,
        water: e2eOceanEmissions,
      },
      air: airEmissions,
      water: oceanEmissions,
    },
  };
};
